module.exports = "<div class=\"row\">{{title}}</div>\r\n\r\n<div class=\"row\">\r\n    <gfx-list [config]=\"listCfg\" class=\"gfx-list\"></gfx-list>\r\n</div>"